import { axios } from '@ben/api/axios';
import type { ICategory } from '@ben/shared/types/columbia';

export const getCategoriesForEmployer = (
  employer: number | undefined
): (() => Promise<ICategory[]>) => {
  return async (): Promise<ICategory[]> => {
    if (!employer) {
      return [];
    }
    const response = await axios.get<ICategory[]>(
      `employers/${employer}/benefit-categories/`
    );
    return response?.data;
  };
};

export const addCategoryToEmployer = (
  employer: number,
  category: Omit<ICategory, 'id'>
) => {
  return async (): Promise<unknown> => {
    const response = await axios.post<unknown>(
      `employers/${employer}/benefit-categories/`,
      category
    );
    return response?.data;
  };
};
